import request from "../request"

/**
 * 轮播图列表
 * @param {*}  
 * @returns 
 */
const getCarouselList = () => request.get(`/v1/nf/open/advertisement/list`)

/**
 * 首页服务动态
 * @returns 
 */
const getServiceList = () => request.get(`/v1/nf/open/post/show`)

/**
 * 首页需求动态
 * @returns 
 */
const getDemandList = () => request.get(`/v1/nf/open/post/require/show`)

/**
 * 组织名录
 * @returns 
 */
const getCompanyList = (queryParams) => request.post(`/v1/nf/open/auth/company/show`, queryParams)

const apiList = {
  getSerList: () => request.post(`/v1/nf/open/new/show/post/list`),
  getDemList: () => request.post(`/v1/nf/open/new/show/require/list`),
}


const home = {
  getCarouselList,
  getServiceList,
  getDemandList,
  getCompanyList,
  apiList,
}

export default home
